import { TextArea } from '@e2n/ui/v2';
import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { FieldProps } from '@/domain/mitarbeiter/shared/components/form/types';
import { useFieldContext } from '@/domain/mitarbeiter/shared/components/form/hooks';

export function TextAreaInput({
  label,
  description,
  placeholder,
  className,
  isRequired,
  showCounter,
  maxLength,
  ...props
}: FieldProps & React.ComponentProps<'textarea'> & { showCounter?: boolean }) {
  const field = useFieldContext<string>();
  return (
    <FieldBase label={label} description={description} isRequired={isRequired}>
      <TextArea
        id={field.name}
        name={field.name}
        className={className}
        placeholder={placeholder}
        value={field.state.value ?? ''}
        onChange={(e) => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
        showCount={showCounter}
        maxLength={maxLength}
        {...props}
      />
    </FieldBase>
  );
}
